// Copyright 2017 Rigo Investment Sagl.
// This file is part of RigoBlock.

import PoolsApi from './api'

export default PoolsApi
